<template lang="pug">
    .post-comments
        scrollable-layout.post-comments__items(:style="listStyles" ref="comments")
            .post-comments__item(v-for="comment in comments")
                creator-control(:creator="comment.user.data" description=" ")
                .post-comments__item-description(v-html="comment.message")
                .post-comments__item-info
                    .post-comments-item-info__date {{ formatDate(comment.created_at) }}
                    .post-comments-item-info__reply(@click="reply(comment)") Reply
        .post-comments__input
            .post-comments__input-label Leave a comment
            .post-comments__input-block
                creator-control(:creator='authUser' :include-info="false")
                emoji-picker-control(@append='appendEmoji')
                .post-comments__input-block-field
                    re-input(
                        ref="messageInput"
                        name="message"
                        placeholder="Type a message here..."
                        v-model="message"
                        @keyup.native.enter="sendComment"
                    )
                    creator-mention-dropdown-control(v-if="textEl" :textEl="textEl")
                .post-comments__input-block-button(@click="sendComment")
                    svg-icon(iconId="paper-plane")
</template>

<script>
import postCommentService from "../services/post-comment-service";
import moment from "moment";
import {mapGetters} from "vuex";

export default {
    name: 'post-comments',
    props: {
        postId: {
            type: String,
            required: true
        },
        user: {
            type: Object,
            required: true
        },
        comments: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            message: '',
            textEl: null,
        }
    },
    computed: {
        ...mapGetters(['authUser']),

        listStyles() {
            return this.comments.length < 3 ? { height: (this.comments.length * 80) + 'px' }: { height: '200px' }
        },
    },
    methods: {
        sendComment() {
            if (this.message) {
                postCommentService.store(this.postId, this.message)
                    .then(({data}) => {
                        this.$emit('sendComment', data.data)

                        this.message = ''
                    })
            }
        },
        formatDate(date) {
            const m = moment(date)

            if (m.year() == moment().year()) {
                return m.format('MMM D, h:mm A')
            }

            return m.format('MMM D YYYY, h:mm A')
        },
        reply(comment) {
            if (comment.user.data.username) {
                this.message = `${this.message}${this.message.length > 0 ? ' ' : ''}@${comment.user.data.username}`
                this.focusMessageInput()
            }
        },
        appendEmoji(emoji) {
            this.message += emoji

            this.focusMessageInput()
        },
        focusMessageInput() {
            this.$refs.messageInput.$el.children[0].focus()
        },
        scrollToLastComment() {
            this.$refs.comments.scrollToBottom()
        },
    },

    mounted() {
        this.textEl = this.$refs.messageInput.$el.querySelector('input.form-control')
    },
}
</script>
